import React from "react";
import { Link } from "react-router-dom";

const QUESTIONS = [
  { q: "Comment savoir quels commerces sont partenaires ?", a: "Tous les partenaires sont listés dans l’application et sur le site. Cherche par catégorie ou par quartier pour les retrouver facilement." },
  { q: "Comment profiter des offres ?", a: "Présente le QR code de l’app chez le commerçant partenaire ou active l’offre directement depuis la fiche du commerce." },
  { q: "L’app est-elle gratuite ?", a: "Oui, l’application PACTE est gratuite pour les habitants. Les commerçants ont une formule adaptée à leurs besoins." },
  { q: "Puis-je cumuler des points fidélité ?", a: "Oui, chaque commerce peut proposer sa fidélité dans l’app. Tes cartes sont centralisées dans ton téléphone." },
];

function Item({ i, q, a }: { i: number; q: string; a: string }) {
  const [open, setOpen] = React.useState(i === 0); 
  return (
    <div className="rounded-xl bg-[#F6F6F7] border border-black/5">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-4 px-4 sm:px-5 py-3 sm:py-3.5 text-left"
      >
        <span className="text-[14px] sm:text-[15px] font-semibold text-neutral-900">{q}</span>
        <svg
          className={`h-5 w-5 text-neutral-500 transition-transform ${open ? "rotate-180" : ""}`}
          viewBox="0 0 20 20" fill="currentColor"
        >
          <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.06l3.71-2.83a.75.75 0 1 1 .92 1.18l-4.19 3.2a.75.75 0 0 1-.92 0l-4.19-3.2a.75.75 0 0 1-.02-1.06z" />
        </svg>
      </button>

      <div
        className={`grid transition-all duration-300 ease-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
      >
        <div className="overflow-hidden">
          <div className="px-4 sm:px-5 pb-4 sm:pb-5 text-[13px] sm:text-[14px] text-neutral-700">
            {a}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  return (
    <section className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <div className="text-center max-w-3xl mx-auto">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-asap font-semibold">On vous répond!</h2>
        <p className="mt-4 text-[13px] sm:text-[15px] text-neutral-600 leading-relaxed">
          Une question sur PACTE ? On a déjà prévu la réponse ! Que ce soit pour savoir où profiter de vos avantages, comment cumuler des points ou devenir partenaire, on vous explique tout ici de façon simple et rapide.
        </p>
      </div>

      <div className="mt-8 sm:mt-10 max-w-3xl mx-auto flex flex-col gap-3 sm:gap-3.5">
        {QUESTIONS.map((it, i) => (
          <Item key={i} i={i} q={it.q} a={it.a} />
        ))}
      </div>
      <div className="flex items-center justify-center gap-4 mt-8 sm:gap-6">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-full bg-black text-white
                             px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)]
                             hover:opacity-90 transition"
            >
              Toujours une question en tête ? Écrivez-nous !
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-full bg-white text-neutral-900
                            px-6 py-3 text-sm font-medium
                            s shadow-[0_4px_4px_rgba(0,0,0,0.25),_inset_0_0_10px_rgba(0,0,0,0.2)]
                            hover:bg-white/95 transition"
            >
              Echangeons lors d'un appel 
            </Link>
          </div>
    </section>
  );
}